import React from 'react';

const PropertyCreate = () => {
  return <div>PropertyCreate</div>;
};

export default PropertyCreate;
